export class DeterministicRandom {
  private state: number;

  constructor(seed = 0x6d2b79f5) {
    this.state = seed >>> 0 || 1;
  }

  reset(seed: number): void {
    this.state = seed >>> 0 || 1;
  }

  nextU32(): number {
    let x = this.state;
    x ^= x << 13;
    x ^= x >>> 17;
    x ^= x << 5;
    this.state = x >>> 0;
    return this.state;
  }

  nextFloat(): number {
    return this.nextU32() / 0x100000000;
  }

  range(min: number, max: number): number {
    return min + (max - min) * this.nextFloat();
  }

  int(maxExclusive: number): number {
    return maxExclusive <= 1 ? 0 : this.nextU32() % maxExclusive;
  }
}
